import template from './template.html'
import Controller from './pitchCard.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    pitch: '=',
  },
  controller: Controller,
  controllerAs: 'vm',
}
